let installed = false;

const listeners = new Map();
const onceResolvers = new Map();

function emit(event, payload) {
    const set = listeners.get(event);
    if (set) for (const cb of set) cb(payload);

    const queue = onceResolvers.get(event);
    if (queue && queue.length) {
        const resolve = queue.shift();
        resolve(payload);
    }
}

function on(event, cb) {
    if (!listeners.has(event)) listeners.set(event, new Set());
    listeners.get(event).add(cb);
    return () => off(event, cb);
}

function off(event, cb) {
    const set = listeners.get(event);
    if (!set) return;
    set.delete(cb);
    if (set.size === 0) listeners.delete(event);
}

function once(event) {
    return new Promise((resolve) => {
        if (!onceResolvers.has(event)) onceResolvers.set(event, []);
        onceResolvers.get(event).push(resolve);
    });
}

function isIOS() {
    return /iPhone|iPad/i.test(navigator.userAgent);
}
function isAndroid() {
    return /Android/i.test(navigator.userAgent);
}

function send(action, params) {
    try {
        if (isIOS()) {
            window.webkit?.messageHandlers?.JphIOS?.postMessage?.({
                action,
                params: params ? params : {},
            });
            return;
        }

        if (isAndroid()) {
            if (typeof Jph !== "undefined" && Jph) {
                const fn = Jph?.[action];
                if (typeof fn === "function") {
                    const values = params ? Object.values(params) : [];
                    fn.call(Jph, ...values);
                } else {
                    console.warn(`[Tiger] Android action no existe: ${action}`);
                }
            } else {
                console.warn("[Tiger] No existe Jph (web normal?)");
            }
            return;
        }

        console.warn("[Tiger] Plataforma no soportada (web normal)");
    } catch (e) {
        console.error(`Error Tiger send(${action}):`, e?.message || e);
    }
}

function installWindowHandlers() {
    if (installed) return;
    installed = true;

    window.tigerGetLocation = (latitude, longitude) =>
        emit("location", { latitude, longitude });

    window.tigerGetScan = (scan) => emit("scan", scan);

    window.tigerGetTokenNewPN = (token) => emit("token", token);

    window.tigerIsAvailableResultBiometric = (value) =>
        emit("biometric:available", value);

    window.tigerGetVideoNameGallery = (value) =>
        emit("video:name", value);

    window.TigerUpdateOnlineStatus = (status) =>
        emit("online", status);

    window.tigerGetPicture = (base64Image) =>
        emit("camera:photo", base64Image);

    window.tigerReceiveFileFromMobile = (base64String, contentType, fileName) =>
        emit("file", { base64String, contentType, fileName });

    window.tigerResultBiometric = (boolean, description, errorCode, idUsuario, idDevice) =>
        emit("biometric:result", { boolean, description, errorCode, idUsuario, idDevice });
}

export default {
    installWindowHandlers,
    send,
    on,
    off,
    once,
};
